import { Injectable, Injector } from '@angular/core';
import { LoqateProvider } from './providers/loqate.provider';
import { PostcodeLookupServiceInterface } from './postcode-lookup-service-interface';
import { FetchifyProvider } from './providers/fetchify.provider';

@Injectable()
export class PostcodeLookupSericeFactory {
  private providers = {
    loqate: LoqateProvider,
    fetchify: FetchifyProvider,
  };

  constructor(private injector: Injector) {}

  getProvider(providerName): PostcodeLookupServiceInterface {
    const providerClass = this.providers[providerName];

    if (!providerClass) {
      throw new Error(`Provider '${providerName}' not found`);
    }

    return this.injector.get(providerClass);
  }
}
